import { useState, useEffect, useCallback } from 'react';
import client from '../api/client';

export default function useOdds(sport) {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetch = useCallback(() => {
    if (!sport) return;
    setLoading(true);
    setError(null);
    client
      .get(`/api/odds/${sport}`)
      .then((res) => setEvents(res.data))
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  }, [sport]);

  useEffect(() => {
    fetch();
  }, [fetch]);

  return { events, loading, error, refetch: fetch };
}
